import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

// Attribution footer shared by the history row and the record detail: who logged
// the record and, when it was voided, who voided it.
const ServiceRecordAttribution: FunctionComponent<Props> = ({
    className = '',
    record,
    testId = TEST_ID
}) => {
    const t = useTranslation();

    return (
        <VerticalContainer
            className={`${styles.serviceRecordAttribution} ${className}`}
            testId={testId}>
            <Wrapper className={styles.attribution}>
                {t.SERVICE_RECORD_BY({
                    when: new Date(record.at).toLocaleDateString(),
                    who: record.by
                })}
            </Wrapper>

            {record.voided && (
                <Wrapper className={styles.voidedBy}>
                    {t.SERVICE_VOIDED_BY({
                        when: record.voidedAt ? new Date(record.voidedAt).toLocaleDateString() : '',
                        who: record.voidedBy ?? ''
                    })}
                </Wrapper>
            )}
        </VerticalContainer>
    );
};

export default ServiceRecordAttribution;
